import React, {useEffect, useState} from 'react'
import {inject, observer} from 'mobx-react'
import {Image, Table, message} from 'antd'
import {PlayCircleOutlined} from '@ant-design/icons'
import {queryClientList, getMediaWallList, getMonitorList, getStationInfo, getSwitchLoopList, getWarningList, pageSmcList, 
  getRegionDeviceList, listSwitch, getStrongAlarmInfo, playFragment} from '@apis'
import cs from 'classnames'
import mediaMarker from '@assets/img/node.png'
import electricMarker from '@assets/img/electric.png'
import monitorMarker from '@assets/img/monitor.png'
import mediaWarningMarker from '@assets/img/nodeWarning.png'
import electricWarningMarker from '@assets/img/electricWarning.png'
import markerIntegrate from '@assets/img/markerIntegrate.png'
import mapBg from '@assets/img/mapBg.png'

let LMap = null

const onlineStatus = [
  '未在线',
  '在线',
  '未安装监控'
]

const IndexChart = inject('store')(
  observer(({store}) => {
    const {userInfo = {}} = store
    const {brokerId, brokerLocation, strongProjectId: projectId} = userInfo
    const [nodeChat, setNodeChat] = useState([])
    const [showType, setShowType] = useState(0)
    const [loadingTable, setLoadingTable] = useState(false)
    const [mediaWallList, setMediaWallList] = useState()
    const [monitorList, setMonitorList] = useState()
    const [deviceList, setDeviceList] = useState()
    const [smcList, setSmcList] = useState()

    // 获取信息列表
    function getClientList() {
      const params = {
        pageNo: 1,
        pageSize: 9999,
      }
      if (brokerId > 0) {
        params.brokerId = brokerId
      }
      queryClientList().then(res => {
        if (res && res.data) {
          getMediaWallList(params).then(media => {
            if (media && media.data) {
              const node = []
              media.data.map(item => {
                res.data.data.map(i => {
                  if(item.code == i.appCode) {
                    item.dateTime = i.dateTime
                    item.lastPicPath = location.origin + "/security/" + i.lastPicPath
                  }
                })
                node.push(item)
              })
              setMediaWallList(node)
            }
          }).catch(e =>{
            setMediaWallList([])
          })
        }
      }).catch(e => {
        setMediaWallList([])
        message.error(e)
      })
    }
    
    // 查询监控列表
    function queryMonitorList() {
      const params = {
        brokerId: brokerId,
      }
      getMonitorList(params).then(res => {
        if (res && res.data) {
          setMonitorList(res.data)
        }
      }).catch(e => {
        setMonitorList([])
      })
    }

    // 获取设备列表
    async function queryDeviceList() {
      const params = {
        brokerId,
        projectId,
        pageNo: 1,
        pageSize: 9999,
      }
      const res = projectId ? await getStationInfo(params) : await getRegionDeviceList(params)
      const item = projectId ? await getSwitchLoopList(params) : await listSwitch(params)
      const warning = projectId ? await getWarningList(params) : await getStrongAlarmInfo(params)
      let warn
      if (warning && warning.data) {
        warn = warning.data.filter(value => value.r===false)
      }
      res.data.map(values => {
        if(projectId) {
          values.SwitchLoopList = item.data.filter(i => (i.stationId == values.stationId
          ))
        } else {
          values.lat = JSON.parse(values.stationLocation).location[1]
          values.lng = JSON.parse(values.stationLocation).location[0]
        }
        warn.map(value => {
          if(value.cuid == values.cuid) {
            values.warning = true
          }
        })
      })
      if (res) {
        setDeviceList(res.data)
      }
    }

    // 获取融合设备列表
    async function getSmcList() {
      const params = {
        brokerId,
        pageNo: 1,
        pageSize: 999,
        type: 2
      }
      const res = await pageSmcList(params)
      if(res && res.data) {
        setSmcList(res.data.map(item => ({
          ...item,
          key: item.id,
          lat: JSON.parse(item.location)[1],
          lng: JSON.parse(item.location)[0],
          content: JSON.parse(item.content).map((value, index) => ({
            ...value,
            onlineStatus: item.onlineStatus,
            nodeId: item.id,
            key: index
          }))
        })))
      } else {
        setSmcList([])
      }
    }
    
    // 播放片段
    async function playFragment(value, index) {
      const item = {
        fragmentId: index,
        nodes: value,
      }
      const res = await playFragment(item)
      if(res) {
        message.success('播放成功')
      }
    }

    // 开启地图、创建地图信息
    function initMap() {
      const vector_map=L.tileLayer("http://zns.china-yd.com:20010/1208655691/{z}/{x}/{y}", {
        minZoom: 12,
        maxZoom: 16,
        tileSize: 256,
      }).addTo(LMap);
      //添加注记
      const vector_note=L.tileLayer("http://zns.china-yd.com:20010/1546890191/{z}/{x}/{y}", {
        minZoom: 12,
        maxZoom: 16,
        tileSize: 256,
        zIndex:5,
      }).addTo(LMap);
      const nodeIcon = L.icon({
        iconUrl: mediaMarker,
        iconSize: [35, 35]
      })
      const nodeWarningIcon = L.icon({
        iconUrl: mediaWarningMarker,
        iconSize: [35, 35]
      })
      const electricIcon = L.icon({
        iconUrl: electricMarker,
        iconSize: [35, 35]
      })
      const electricWarningIcon = L.icon({
        iconUrl: electricWarningMarker,
        iconSize: [35, 35]
      })
      const monitorIcon = L.icon({
        iconUrl: monitorMarker,
        iconSize: [35, 35]
      })
      const smcIcon = L.icon({
        iconUrl: markerIntegrate,
        iconSize: [35, 35]
      })
      mediaWallList.map(item => {
        const location = [JSON.parse(item.location).location[1], JSON.parse(item.location).location[0]]
        const nodeMarker = L.marker(location, {icon: item.onlineStatus ? nodeIcon : nodeWarningIcon}).addTo(LMap)
        if(!item.onlineStatus) {
          setInterval(() => {
            nodeMarker.setIcon(nodeIcon)
          }, 1000)
          setTimeout(() => {
            setInterval(() => {
              nodeMarker.setIcon(nodeWarningIcon)
            }, 1000)
          }, 500)
        }
        nodeMarker.on('click', function (e) {
          setNodeChat(item)
          setShowType(1)
          document.getElementById('map-show').style.display = 'block'
        })
      })
      monitorList.map(item => {
        const location = [JSON.parse(item.location).location[1], JSON.parse(item.location).location[0]]
        const monitorMarker = L.marker(location, {icon: monitorIcon}).addTo(LMap)
        monitorMarker.on('click', function (e) {
          setNodeChat(item)
          setShowType(2)
          document.getElementById('map-show').style.display = 'block'
        })
      })
      deviceList.map(item => {
        const location = [item.lat, item.lng]
        const deviceMarker = L.marker(location, {icon: item.warning ? electricWarningIcon : electricIcon}).addTo(LMap)
        if(item.warning) {
          setInterval(() => {
            deviceMarker.setIcon(electricIcon)
          }, 1000)
          setTimeout(() => {
            setInterval(() => {
              deviceMarker.setIcon(electricWarningIcon)
            }, 1000)
          }, 500)
        }
        deviceMarker.on('click', function (e) {
          setNodeChat(projectId ? item.SwitchLoopList : item.listSwitchInfo)
          setShowType(3)
          document.getElementById('map-show').style.display = 'block'
        })
      })
      smcList.map(item => {
        const location = [item.lat, item.lng]
        const smcMarker = L.marker(location, {icon: item.onlineStatus ? smcIcon : smcIcon}).addTo(LMap)
        if(item.warning) {
          setInterval(() => {
            smcMarker.setIcon(smcIcon)
          }, 1000)
          setTimeout(() => {
            setInterval(() => {
              smcMarker.setIcon(smcIcon)
            }, 1000)
          }, 500)
        }
        smcMarker.on('click', function (e) {
          setNodeChat(item.content)
          setShowType(4)
          document.getElementById('map-show').style.display = 'block'
        })
      })
    }

    // 创建地图
    function createLMap(location) {
      location = location.lat ? location : JSON.parse(location)
      const corner1 =  L.latLng(Number(location.lat)+0.07, Number(location.lng)-0.15) //设置左上角经纬度
      const corner2 = L.latLng(Number(location.lat)-0.07, Number(location.lng)+0.15)	//设置右下点经纬度
      const bounds = L.latLngBounds(corner1, corner2)
      LMap = L.map('map_container', {
        crs: L.CRS.EPSG3857,
        zoomControl: true,
        editable:true,
        maxBounds: bounds,
      }).setView([location.lat,location.lng], 16);
      LMap.on('click', function() {
        document.getElementById('map-show').style.display = 'none'
      })
    }

    useEffect(() => {
      if(LMap) {
        LMap.remove()
        LMap = null
      }
      if(!LMap) {
        createLMap(JSON.parse(brokerLocation))
      }
      getClientList()
      queryMonitorList()
      queryDeviceList()
      getSmcList()
    }, [])

    useEffect(() => {
      if(mediaWallList && monitorList && deviceList && smcList) {
        initMap()
      }
    }, [mediaWallList, monitorList, deviceList, smcList])

    const columns = [{
      title: '配电柜名称',
      key: 'name',
      dataIndex: 'name',
    }, {
      title: '开关',
      key: 'k',
      width: 60,
      render: row => (
        <div>{row.kadd}-{row.kch}</div>
      )
    }, {
      title: '状态',
      key: 'status',
      dataIndex: 'name',
      render: text => text ? '开启' : '关闭'
    }]

    const fragmentColumns = [{
      title: '片段ID',
      key: 'id',
      width: 80,
      dataIndex: 'id'
    }, {
      title: '片段名称',
      key: 'name',
      width: 90,
      dataIndex: 'name'
    }, {
      title: '操作',
      key: 'operate',
      fixed: 'right',
      render: row => (
        <span
          className="edit-sp pg-play"
          onClick={() => {
            if(!row.onlineStatus) return message.warning('该设备未在线，无法播放片段')
            playFragment([row.nodeId], row.id)
          }}
          type="text"
        >
          <PlayCircleOutlined className="play-icon" />
          播放片段
        </span>
      )
    }]

    return (
      <div className="ck-index-map">
        <div className="ck-index-map_container" id="map_container">
        </div>
        <img className='ck-index-img' src={mapBg}/>
        <div className={cs({
          'map-show': showType<3,
          'electricbg': showType>2,
          'electric': showType==3,
        })} id='map-show'>
          {
            showType==1 && (
              <div>
                <div>节点名称: {nodeChat.name}</div>
                <div>节点在线状态: {onlineStatus[nodeChat.onlineStatus]}</div>
                <div>桌面监控:  {onlineStatus[new Date(nodeChat.dateTime).valueOf()+5*60*1000 > new Date().valueOf() ? '1' : '0']}</div>
                {
                  nodeChat.lastPicPath && (<Image style={{width:"100%"}} src={nodeChat.lastPicPath}/>)
                }
              </div>
            )
          }
          {
            showType==2 && (
              <div>
                <div>设备名称：{nodeChat.name}</div>
                <iframe
                  src={`https://open.ys7.com/ezopen/h5/iframe?url=${nodeChat.url}&autoplay=1&accessToken=${nodeChat.monitorAccessToken}`}
                  width="100%"
                  height={200}
                  allowfullscreen
                />
              </div>
            )
          }
          {
            showType==3 && (
              <div>
                <Table
                  columns={columns}
                  dataSource={nodeChat[0] ? nodeChat : null}
                  loading={loadingTable}
                  pagination={false}
                  scroll={{x: 'max-content', y: '200px'}}
                />
              </div>
            )
          }
          {
            showType==4 && (
              <div>
                <Table
                  columns={fragmentColumns}
                  dataSource={nodeChat[0] ? nodeChat : null}
                  loading={loadingTable}
                  pagination={false}
                  scroll={{x: 'max-content', y: '200px'}}
                />
              </div>
            )
          }
        </div>
      </div>
    )
  })
)

export default IndexChart
